// extracted by mini-css-extract-plugin
export default {"wrapper":"D3-z"};